import handler from 'api/handler'

const prefix = '/admin/business'

const methods = {
  updateApprovalStatus: args => handler({ method: 'put', url: prefix + '/updateApprovalStatus', args }),
  fetchNewlyCreated: args => handler({ method: 'get', url: prefix + '/fetchNewlyCreated', args }),
  checkUserBusiness: args => handler({ method: 'get', url: prefix + '/checkUserBusiness', args }),
  fetchAllWithUsers: args => handler({ method: 'get', url: prefix + '/fetchAllWithUsers', args })
}

export default methods
